<template>
  <div class="Representativeness">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex d-flex xs12 md8>
          <v-card class="mb-2">
            <v-card-title class="title">
              Representatividad de Encuestas por Localidad y Estrato Social
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <chart-column
                :chartOptions="chartOptions"
                :chartSeries="chartSeries"
                :key="chartRELESKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex d-flex xs8 md4>
          <v-card class="mb-2">
            <v-card-title class="title">
              Representatividad por Estrato Social
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <chart-pie
                :chartOptions="chartOptionsEstr"
                :chartSeries="pieEstr"
                :key="chartRESKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex d-flex xs12 md6 v-if="loadMuestra || dataValsMuestra.length > 0">
          <v-card>
            <v-card-title class="title">
              Tabla de Avance de Encuestas por Localidad
              <v-spacer/>
              <v-card-actions v-if="dataValsMuestra.length > 0">
                <v-btn color="info" :disabled="dataValsMuestra.length < 1">
                  <download-csv
                    :data="dataValsMuestra"
                    :name="'Tabla de Avance de Encuestas por Localidad.csv'"
                    :labels="labelsMuestra"
                    :fields="fieldsMuestra"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadMuestra"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-if="dataValsMuestra.length > 0">
              <data-table
                :headers="headersMuestra"
                :dataVals="dataValsMuestra"
                :searchActive="true"
                :key="tableMuestraKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex d-flex xs12 xl10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Avance de Encuestas por Localidad
            </v-card-title>

            <v-card-text
              v-if="operativo !== 21 ? loading : loadMuestra"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <chart-column
                :chartOptions="chartOptions100"
                :chartSeries="chartSeries100"
                :key="chartAELKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import chartColumn from '@/components/Charts/ColumnBase'
import chartPie from '@/components/Charts/PieBase'

import dataTable from '@/components/Tables/TableWithTotals'
import JsonCSV from 'vue-json-csv'

export default {
  name: 'Representativeness',

  components: {
    chartColumn,
    chartPie,
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.correction()
  },

  data: function () {
    return {
      backConf: {
        path: '/ccb/rpestrato',
        pathMuestra: '/charts/muestra/',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      operativo: null,

      headersMuestra: [],
      dataValsMuestra: [],
      labelsMuestra: {},
      fieldsMuestra: [],
      tableMuestraKey: 0,
      loadMuestra: false,

      chartSeries: null,
      chartOptions: {
        chart: {
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800'
        ],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          }
        },

        xaxis: {
          categories: [
            'Usaquén', 'Chapinero', 'Santa Fe', 'San Cristóbal', 'Usme', 'Tunjuelito',
            'Bosa', 'Kennedy', 'Fontibón', 'Engativá', 'Suba', 'Barrios Unidos',
            'Teusaquillo', 'Los Mártires', 'Antonio Nariño', 'Puente Aranda',
            'La Candelaria', 'Rafael Uribe Uribe', 'Ciudad Bolívar', 'Sumapaz'
          ],
          title: {
            text: 'Localidad'
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {}
        }
      },
      chartRELESKey: 0,

      chartSeries100: null,
      chartOptions100: {
        chart: {
          height: 350,
          toolbar: {
            show: true
          }
        },
        colors: ['#3DD33D', '#D33D3D'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '95%',
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 0,
          colors: ['#aaa']
        },

        xaxis: {
          categories: [
            'Usaquén', 'Chapinero', 'Santa Fe', 'San Cristóbal', 'Usme', 'Tunjuelito',
            'Bosa', 'Kennedy', 'Fontibón', 'Engativá', 'Suba', 'Barrios Unidos',
            'Teusaquillo', 'Los Mártires', 'Antonio Nariño', 'Puente Aranda',
            'La Candelaria', 'Rafael Uribe Uribe', 'Ciudad Bolívar', 'Sumapaz'
          ],
          title: {
            text: 'Número de Encuestas'
          }
        },
        yaxis: {
          title: {
            text: 'Localidad'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {}
        }
      },
      chartAELKey: 0,

      pieEstr: null,
      chartOptionsEstr: {
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800'
        ],
        labels: null,
        legend: {
          position: 'bottom'
        }
      },
      chartRESKey: 0
    }
  },

  methods: {
    /**
     * Carga los datos de las encuestas
     */
    loadData () {
      this.loading = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeries = resp.data
          t.chartRELESKey += 1
          t.totalEstrato()

          if (t.operativo !== 21) {
            t.totalProgress()
          }
          t.loading = false
        })
        .catch(function (err) {
          t.chartSeries = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Procesa los datos para la tabla cobertura agregando los datos faltantes de la tabla
     */
    processMuestra () {
      this.loadMuestra = true
      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathMuestra
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          // obtiene las keys para values, retirando los de meta y conteo
          let vals = Object.keys(resp.data[0])
          vals.splice(vals.length - 2)
          let totMeta = 0
          let totCont = 0

          // calcualr el porcentaje y formatea los datos
          resp.data.forEach(function (element) {
            totMeta += element.meta
            totCont += element.conteo

            let perc = element.conteo / element.meta * 100
            perc = Number.parseFloat(perc).toFixed(1)

            let obj = {
              meta: element.meta,
              conteo: element.conteo,
              porcentaje: perc === 'NaN' ? Number.parseFloat(0).toFixed(1) : perc
            }
            // agrega las keys y los valores de los values, para mostrar
            vals.forEach(function (key) {
              obj[key] = element[key]
            })

            t.dataValsMuestra.push(obj)

            t.chartOptions100.xaxis.categories.push(element[vals[0]])
            t.chartSeries100[0].data.push(element.conteo)
            t.chartSeries100[1].data.push(element.meta)
          })

          let ponder = totCont / totMeta * 100
          t.tableConfig(vals, Number.parseFloat(ponder).toFixed(1))

          t.tableMuestraKey += 1
          t.loadMuestra = false
        })
        .catch(function (err) {
          t.dataValsMuestra = []
          t.loadMuestra = false
          console.error(err)
        })
    },

    /**
     * Confogura valores necesarios para el funcioanimiento de la tabla,
     * headers, labels y fields
     * @param  {array}   values Lista de valores a agregar
     * @param  {integer} ponder Valor ponderado, para adjuntar a la tabla
     */
    tableConfig (values, ponder) {
      console.log(values)

      let head = []

      values.forEach(function (key) {
        let obj = {
          text: key,
          align: 'left',
          value: key,
          str: ' '
        }
        head.push(obj)
      })

      head[head.length - 1].str = 'Totales'

      this.headersMuestra = head.concat([
        { text: 'Muestra', value: 'meta', align: 'right' },
        { text: 'Conteo', value: 'conteo', align: 'right' },
        { text: 'Avance %', value: 'porcentaje', align: 'right', str: ponder }
      ])

      // Agrega los Labels para el CSV
      let obj = {}

      values.forEach(function (key) {
        obj[key] = key
      })

      this.labelsMuestra = Object.assign(obj, {
        meta: 'Muestra',
        conteo: 'Conteo',
        porcentaje: 'Avance'
      })

      // Agrega los Fields para el CSV
      this.fieldsMuestra = values.concat(['meta', 'conteo', 'porcentaje'])
    },

    /**
     * Calcula los valores de las sumatorias de los estratos
     */
    totalEstrato () {
      var sums = []
      let estratos = []
      this.chartSeries.forEach(function (element) {
        estratos.push(element.name)
        sums.push(element.data.reduce(function (accumulator, val) {
          return accumulator + (val || 0)
        }, 0))
      })

      this.pieEstr = sums
      this.chartOptionsEstr.labels = estratos
      this.chartRESKey += 1
    },

    /**
     * Calcula los valores de las sumatorias de las localidades
     */
    totalProgress () {
      var completados = []
      for (var i = 0; i < 20; i++) {
        let val = this.chartSeries.reduce(function (accumulator, val) {
          return accumulator + (val.data[i] ? val.data[i] : 0)
        }, 0)
        completados.push(val)
      }
      this.chartSeries100[0].data = completados
      this.chartAELKey += 1
    },

    /**
     * Realiza los cambios a la configuración de las graficas segun el operativo
     */
    correction () {
      if (this.operativo === 1) { // CCB V1
        this.chartSeries100 = [
          {
            name: 'Completados',
            data: null
          },
          {
            name: 'Muestra',
            data: [504, 502, 503, 503, 503, 503, 504, 503, 504, 503, 503, 502,
              503, 503, 502, 502, 502, 503, 504, 0]
          }
        ]

        this.chartOptions.tooltip.y = {
          formatter: function (val) {
            let per = (val * 100) / 503 // el valor 503 es la muestra
            return val + ' / ' + parseFloat(per).toFixed(1) + '%'
          }
        }

        this.chartOptions100.tooltip.y = {
          formatter: function (val) {
            let per = (val * 100) / 503 // el valor 503 es la muestra
            return val + ' / ' + parseFloat(per).toFixed(1) + '%'
          }
        }
        this.loadData()
      } else if (this.operativo === 5) { // CCB telefonico
        this.chartSeries100 = [
          {
            name: 'Completados',
            data: null
          }
        ]

        this.chartOptions.tooltip.y = {
          formatter: function (val) {
            return val
          }
        }

        this.chartOptions100.tooltip.y = {
          formatter: function (val) {
            return val
          }
        }
        this.loadData()
      } else if (this.operativo === 21) { // CCB V2
        this.chartOptions100.xaxis.categories = []

        this.chartSeries100 = [
          {
            name: 'Completados',
            data: []
          },
          {
            name: 'Muestra',
            data: []
          }
        ]

        this.loadData()
        this.processMuestra()
      } else if (this.operativo === 26) { // CCB telefonico V2
        this.chartSeries100 = [
          {
            name: 'Completados',
            data: null
          }
        ]

        this.chartOptions.tooltip.y = {
          formatter: function (val) {
            return val
          }
        }

        this.chartOptions100.tooltip.y = {
          formatter: function (val) {
            return val
          }
        }
        this.loadData()
      }
    }
  }
}
</script>
